<template>
    <router-link v-bind:to="'/blackjack/table/' + (table.table + 1)" class="blackjack-tables-element">
        <div class="element-inner">
            <div class="inner-info">
                <div class="info-name"><span class="lobby-text">LOBBY</span> {{displayNumber !== undefined ? displayNumber : (table.table + 1)}}</div>
                <div class="info-players">
                    <div class="players-avatars">
                        <div v-if="table.players.length === 0" class="player-avatar placeholder">
                            <div class="avatar-placeholder"></div>
                        </div>
                        <div v-for="(player, index) of table.players.slice(0, 2)" v-bind:key="player.user._id || index" class="player-avatar" v-bind:style="{ zIndex: 2 - index, marginLeft: index > 0 ? '-8px' : '0' }">
                            <AvatarImage v-bind:image="player.user.avatar" />
                        </div>
                    </div>
                    <span class="players-count" v-bind:class="{ 'count-positive': table.players.length < 5, 'count-negative': table.players.length >= 5 }">
                        {{table.players.length < 5 ? '+' : ''}}{{5 - table.players.length}}
                    </span>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import AvatarImage from '@/components/AvatarImage';

    export default {
        name: 'BlackjackTablesElement',
        props: ['table', 'displayNumber'],
        components: {
            AvatarImage
        }
    }
</script>

<style scoped>
    a.blackjack-tables-element {
        width: calc(20% - 8px);
        height: 150px;
        position: relative;
        margin-top: 10px;
        margin-right: 10px;
    }

    a.blackjack-tables-element:nth-child(1),
    a.blackjack-tables-element:nth-child(2),
    a.blackjack-tables-element:nth-child(3),
    a.blackjack-tables-element:nth-child(4),
    a.blackjack-tables-element:nth-child(5) {
        margin-top: 0;
    }

    a.blackjack-tables-element:nth-child(5n) {
        margin-right: 0;
    }

    a.blackjack-tables-element::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.1);
        box-shadow: inset 0px 0px 25px rgba(0, 0, 0, 0.37);
        border-radius: 20px;
        transition: all 0.3s ease;
    }

    a.blackjack-tables-element:hover::before {
        background: rgba(255, 107, 0, 0.2);
    }

    a.blackjack-tables-element::after {
        content: '';
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        background-image: url('~@/assets/img/blackjack/preview.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-color: var(--bg-tertiary);
        border-radius: 20px;
    }

    a.blackjack-tables-element .element-inner {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        background: none;
        border-radius: 20px;
        transition: all 0.3s ease;
        z-index: 1;
    }

    a.blackjack-tables-element:hover .element-inner {
        background: radial-gradient(140% 80% at 85% 50%, rgba(255, 107, 0, 0.15) 0%, rgba(0, 0, 0, 0) 100%), linear-gradient(255deg, rgba(255, 107, 0, 0.05) -50%, rgba(255, 138, 0, 0.05) 100%);
    }

    a.blackjack-tables-element .inner-info {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    a.blackjack-tables-element .info-name {
        white-space: nowrap;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 28px;
        font-weight: 900;
        background: linear-gradient(90.72deg, #ECAD46 0.36%, #FFF173 99.73%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: #FFF173; /* Fallback for browsers that don't support gradient text */
    }

    a.blackjack-tables-element .inner-info .info-players {
        display: flex;
        align-items: center;
        margin-top: 10px;
    }

    a.blackjack-tables-element .inner-info .players-avatars {
        display: flex;
        align-items: center;
    }

    a.blackjack-tables-element .inner-info .player-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid var(--bg-tertiary);
        overflow: hidden;
        position: relative;
    }

    a.blackjack-tables-element .inner-info .player-avatar .avatar-image {
        width: 100%;
        height: 100%;
    }

    a.blackjack-tables-element .inner-info .player-avatar .avatar-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    a.blackjack-tables-element .inner-info .player-avatar.placeholder .avatar-placeholder {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
        border-radius: 50%;
    }

    a.blackjack-tables-element .inner-info .players-count {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 700;
    }

    a.blackjack-tables-element .inner-info .players-count.count-positive {
        color: #00FFC2;
    }

    a.blackjack-tables-element .inner-info .players-count.count-negative {
        color: #DC143C;
    }

    @media only screen and (max-width: 1050px) {

        a.blackjack-tables-element {
            width: calc(25% - 7.5px);
        }

        a.blackjack-tables-element:nth-child(5) {
            margin-top: 10px;
        }

        a.blackjack-tables-element:nth-child(5n) {
            margin-right: 10px;
        }

        a.blackjack-tables-element:nth-child(4n) {
            margin-right: 0;
        }

    }

    @media only screen and (max-width: 900px) {

        a.blackjack-tables-element {
            width: calc(33.33% - 6.66px);
        }

        a.blackjack-tables-element:nth-child(4) {
            margin-top: 10px;
        }

        a.blackjack-tables-element:nth-child(4n) {
            margin-right: 10px;
        }

        a.blackjack-tables-element:nth-child(3n) {
            margin-right: 0;
        }

    }

    @media only screen and (max-width: 700px) {

        a.blackjack-tables-element {
            width: calc(50% - 5px);
        }

        a.blackjack-tables-element:nth-child(3) {
            margin-top: 10px;
        }

        a.blackjack-tables-element:nth-child(3n) {
            margin-right: 10px;
        }

        a.blackjack-tables-element:nth-child(2n) {
            margin-right: 0;
        }

        a.blackjack-tables-element .info-name {
            font-size: 22px;
        }

        a.blackjack-tables-element .inner-info svg {
            width: 18px;
            height: 16px;
            margin-top: 8px;
        }

        a.blackjack-tables-element .inner-info span {
            font-size: 15px;
        }

    }

    @media only screen and (max-width: 480px) {

        a.blackjack-tables-element {
            height: 120px;
        }

        a.blackjack-tables-element .info-name {
            font-size: 18px;
        }

        a.blackjack-tables-element .inner-info svg {
            width: 16px;
            height: 14px;
            margin-top: 6px;
        }

        a.blackjack-tables-element .inner-info span {
            font-size: 13px;
        }

    }
</style>
